import React from 'react';
import { jwtDecode } from 'jwt-decode';

import HeadlinePanel from '../Components/HeadlinePanel';

import AMProposedCases from '../Components/TablesForProposedCases/AMProposedCases';
import WorkerProposedCases from '../Components/TablesForProposedCases/WorkerProposedCases';

import Loading from '../Components/Loading';

export default function ProposedCases() {
  const [userId, setUserId] = React.useState('');
  const [userRole, setUserRole] = React.useState('');

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
      setUserRole(decodedToken.role);
    }
  }, []);


  if (!userId || !userRole) {
    return <Loading />;
  }

  return (
    <>
      <div className='mainContainer'>
        <HeadlinePanel label= 'Витрина заявок' type='' />
        <div className='containerInner'>
          {userRole === 'Арбитражный управляющий' ? (
            <AMProposedCases userId={userId} isFromAccount={false} />
          ) : (
            <WorkerProposedCases />
          )}
        </div>
      </div>
    </>
  );
};
